import { call, put, takeEvery } from 'redux-saga/effects';
import {
    FETCH_ORDER_STATUS_OVERVIEW_REQUEST,
    fetchOrderStatusOverviewSuccess,
    fetchOrderStatusOverviewFailure
} from '../actions/fetchOrderStatusOverviewAction';
import { getRequest } from 'api/apiCall';
import captureCustomSentryEvent from "Sentry/captureCustomSentryEvent";

function* fetchOrderStatusOverviewSaga() {
    try {
        const data = yield call(getRequest, '/customers/orders-status-overview');
        yield put(fetchOrderStatusOverviewSuccess(data));
    } catch (error) {
        captureCustomSentryEvent("fetchOrderStatusOverview", error);
        yield put(fetchOrderStatusOverviewFailure(error.message));
    }
}

function* orderStatusOverviewWatcher() {
    yield takeEvery(FETCH_ORDER_STATUS_OVERVIEW_REQUEST, fetchOrderStatusOverviewSaga);
}

export default orderStatusOverviewWatcher;
